import * as z from 'zod';

export const LanguageSettingsSchema = z.object({
  language: z.enum(['en', 'si', 'sr']),
});
